import { render } from "./NotificationListPage.vue?vue&type=template&id=302a41c0"
import script from "./NotificationListPage.vue?vue&type=script&lang=js"
export * from "./NotificationListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__